// https://codepen.io/emmawedekind/pen/eXNppG?editors=1010
import {useField, ErrorMessage} from 'formik';
import {useEffect} from 'react';

import {FormError} from '../../_old/FieldHelpers/FormError';

import {Select} from './Select';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  name: string;
  collection: [string, string][];
  children: React.ReactNode;
  required?: boolean;
  readOnly?: boolean;
  defaultValue?: string;
  className?: string;
};
export function SelectWithFormik(props: Props): React.JSX.Element {
  const [, meta, helpers] = useField(props.name);

  useEffect(() => {
    props.defaultValue && void helpers.setValue(props.defaultValue);
  }, [helpers, props.defaultValue]);

  const toggle = (): void => {
    void helpers.setTouched(true, false);
  };

  const selectFn = (v: string): void => void helpers.setValue(v);

  const errorMessage = <ErrorMessage name={props.name} component={FormError} />;

  return (
    <Select
      collection={props.collection}
      value={meta.value}
      select={selectFn}
      toggle={toggle}
      required={props.required}
      readOnly={props.readOnly}
      className={props.className}

      error={{
        message: meta.touched ? (meta.error ?? '') : '',
        component: errorMessage,
      }}
    >
      {props.children}
    </Select>
  );
}

export function SelectWithFormik2(props: Props): React.JSX.Element {
  const [, meta, helpers] = useField(props.name);

  useEffect(() => {
    props.defaultValue && void helpers.setValue(props.defaultValue);
  }, [helpers, props.defaultValue]);

  const toggle = (): void => {
    void helpers.setTouched(true, false);
  };

  const selectFn = (v: string): void => void helpers.setValue(v);

  const errorMessage = (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {// @ts-expect-error formik zod not sure idk
      meta.error?._errors.map((error) => (
        <FormError key={error}>{error}</FormError>
      ))}
    </>
  );

  return (
    <Select
      collection={props.collection}
      value={meta.value}
      select={selectFn}
      toggle={toggle}
      required={props.required}
      readOnly={props.readOnly}
      className={props.className}
      error={{
        // @ts-expect-error formik zod not sure idk
        message: meta.touched ? (meta.error?._errors ?? '') : '',
        component: errorMessage,
      }}
    >
      {props.children}
    </Select>
  );
}
